import { z } from 'zod';

import { OrganizationId, ProfileId } from 'backend-client-web';

type PersistableForeignVaultSyncPredicate = {
  organizationTeamVaults?: boolean;
  organizationAllVaults?: OrganizationId[];
  organizationPersonalVaultsForProfiles?: { [orgId: string]: ProfileId[] };
  profileAllVaults?: ProfileId[];
};

const PersistableForeignVaultSyncPredicate = z.object({
  organizationTeamVaults: z.boolean().optional(),
  organizationAllVaults: z.array(z.uuid()).optional(),
  organizationPersonalVaultsForProfiles: z.record(z.string(), z.array(z.uuid())).optional(),
  profileAllVaults: z.array(z.uuid()).optional(),
});

export { PersistableForeignVaultSyncPredicate };
